import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ExtensionRequestStore } from './../stores/extensionRequestStore';

export const useExtensionRequestStore = () => useContext<{
  extensionRequestStore: ExtensionRequestStore
}>(StoreContext);
